module.exports = __webpack_public_path__ + "static/img/end.00d41575.png";